import { useQuery } from '@tanstack/react-query';
import { fetchAllPositions } from '../services/positions';

const useAllPositions = () => {
    const getAllPositions = useQuery({
        queryKey: ['allPositions'],
        queryFn: fetchAllPositions
    });
    
    return getAllPositions;
};

export default useAllPositions; 